import { WeekPicker } from "@admin/components/molecules/Picker";
import { endOfWeek } from "date-fns";
import { Dispatch, SetStateAction } from "react";
import { DateRange } from "react-day-picker";
import { useTranslation } from "react-i18next";

import { WeekModel } from "./CopyShiftsWeekModal";

interface WeekPickerProps {
  selectedWeek: DateRange;
  selectedWeeks: WeekModel[];
  setSelectedWeeks: Dispatch<SetStateAction<WeekModel[]>>;
  setSelectedWeekRange: Dispatch<SetStateAction<DateRange | undefined>>;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export function WeekSelection({
  selectedWeek,
  selectedWeeks,
  setSelectedWeeks,
  isOpen,
  setIsOpen,
  setSelectedWeekRange,
}: WeekPickerProps) {
  const { t } = useTranslation();
  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="flex items-baseline flex-row lg:flex-nowrap gap-2.5">
      <label className="form-label flex items-center gap-1 max-w-56 !font-normal !text-gray-800">
        {t("shift.Select Target Weeks")}
      </label>
      <div className="flex flex-col w-full">
        <div className="text-gray-700 rounded-md bg-light border border-gray-300 px-4 py-2 text-base">
          <div
            className="flex items-center justify-between  cursor-pointer"
            onClick={handleToggle}
          >
            <div className="text-gray-800 text-[13px] flex flex-wrap gap-2">
              {selectedWeeks.length > 0 ? (
                selectedWeeks.map((week, index) => (
                  <div
                    key={index}
                    className="flex items-center border border-gray-300 rounded-md px-2 py-1 gap-1"
                  >
                    <span>{week.label}</span>
                    <button
                      onClick={() => {
                        const newSelectedWeeks = selectedWeeks.filter(
                          (_, i) => i !== index,
                        );
                        setSelectedWeeks(newSelectedWeeks);
                      }}
                      className="ml-1 text-gray-500 hover:text-gray-700 text-xs"
                    >
                      &#10005;
                    </button>
                  </div>
                ))
              ) : (
                <span>{t("common.Select Week")}</span>
              )}
            </div>

            <div className="text-gray-500">
              <svg
                className={`w-4 h-4 transform transition-transform ${
                  isOpen ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>

          {isOpen && (
            <div className="mt-2">
              <WeekPicker
                autofill={false}
                setSelectedWeek={setSelectedWeekRange}
                disabledDate={
                  selectedWeek.to
                    ? {
                        before: endOfWeek(selectedWeek.to, { weekStartsOn: 2 }),
                      }
                    : undefined
                }
                isButtonShown={false}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
